import url from './url';


// TODO check url
export default url(() => '/tasks/group_choosing');
